
import { Component, Prop, Watch,FormComponentBase} from "@/lib";
@Component({name:"hi-tree-select"})
export default class HiTreeSelect extends FormComponentBase {
  @Prop({ type: [String, Number, Array], default: "", required: true }) value: any;
  @Prop({ type: Boolean, default: false }) multiple: boolean;
  @Prop({ type: Boolean, default: true }) clearable: boolean;
  @Prop({ type: Array, default: () => { return []; } }) treeData: Array<any>;
  @Prop({ type: Boolean, default: false }) number: boolean;
  @Prop({ type: Boolean, default: false }) leaf: boolean; //仅叶子节点可以选择  仅支持单选的情况

  currentValue = null;
  selectList = [];
  currentTreeData = [];

  get propData() {
    return { value: this.value, treeData: this.treeData };
  }

  toggleExpand(data){

  }

  @Watch("propData", { deep: true, immediate:true })
  watchPropData(propData) {
    this.currentTreeData = [];
    if (
      propData.value != undefined &&
      propData.treeData != null &&
      propData.treeData.length > 0
    ) {
        this.currentValue = propData.value;
        this.currentTreeData = JSON.parse(JSON.stringify(propData.treeData));
        this.setSelectNode();
    }
  }

  setSelectNode() {
    this.currentTreeData.forEach(element => {
      this.loadNode(element);
    });
  }

  loadNode(parentNode) {
    if (parentNode.value == this.currentValue) {
      this.$set(parentNode, "selected", true);
      this.selectList.push(parentNode);
    }
    delete parentNode.primaryKey;
    if (parentNode.children) {
      parentNode.children.forEach(element => {
        this.loadNode(element);
      });
      if (parentNode.children.some(item => {return item.expand === true || item.selected === true;})) {
        this.$set(parentNode, "expand", true);
      }
    }
  }

  clear() {
    this.selectList = [];
    this.currentValue = undefined;
    this.$emit("input", this.currentValue);
    this.currentTreeData = JSON.parse(JSON.stringify(this.treeData));
    this.$emit("on-clear");
  }

  handleSelectChange(selectValue) {
    if (selectValue.length == 0) return;

    //仅限叶子节点可以选择
    if (this.leaf && !this.multiple && selectValue[0].children.length > 0){
      return;
    }

    this.$nextTick(() => {
      this.selectList = [];
      this.currentValue = undefined;
      this.selectList.push(selectValue[0]);
      this.currentValue = selectValue[0].value;
      this.$emit("input", this.currentValue);
      if (!this.multiple) {
        (this.$refs["tree-select"] as any).toggleMenu();
      }
      this.$emit("on-change", {
        value: this.currentValue,
        label: selectValue[0].title
      });
    });
  }

  get requiredRule() {
    return {
      required: true, //是否必填
      type: this.number ? "number" : "string",
      message: this.L("Validate.PleaseSelect", this.L(this.labelKey)), //验证信息
      trigger: "change" //触发方式    常用  blur 和 change}
    };
  }
}
